import "./_slider-styles.scss";

import './view';
